import type { QrTargetType } from '@prospero/shared';

export const qrBindingQueryKeys = {
  all: ['qr-binding'] as const,
  byTarget: (targetType: QrTargetType, targetId: string) =>
    [...qrBindingQueryKeys.all, 'by-target', targetType, targetId] as const,
  byTargets: (targetType: QrTargetType, targetIds: readonly string[]) =>
    [...qrBindingQueryKeys.all, 'by-targets', targetType, targetIds] as const,
  resolve: (qrUuid: string) => [...qrBindingQueryKeys.all, 'resolve', qrUuid] as const,
};
